export default "__VITE_ASSET__Br8rR6NW__"